import { combineReducers } from "@reduxjs/toolkit";

import { newProfileReducer } from "./newProfile/slice";

export default combineReducers({
  newProfile: newProfileReducer,
});
